import { Container, Sprite } from 'pixi.js';
import { AssetLoader } from './AssetLoader';

export class Treat extends Container {
  private sprite: Sprite;
  private isCollected = false;
  private collectionTimer = 0;
  private collectionDuration = 0.3;
  private initialScale = 0.25;
  private targetX = 0;
  private targetY = 0;

  constructor(x: number, y: number) {
    super();

    const assetLoader = AssetLoader.getInstance();
    const texture = assetLoader.getTexture('chicken_treat');

    this.sprite = new Sprite(texture);
    this.sprite.anchor.set(0.5, 0.5);
    this.sprite.scale.set(this.initialScale);

    this.x = x;
    this.y = y;

    this.addChild(this.sprite);
  }

  update(deltaTime: number): void {
    if (!this.isCollected) {
      return;
    }

    this.collectionTimer += deltaTime;
    const progress = Math.min(this.collectionTimer / this.collectionDuration, 1);

    // Scale down and move towards target (cat)
    const scale = this.initialScale * (1 - progress);
    this.sprite.scale.set(scale);

    // Fade out
    this.sprite.alpha = 1 - progress;

    // Move towards cat position
    const currentX = this.x + (this.targetX - this.x) * progress;
    const currentY = this.y + (this.targetY - this.y) * progress;
    this.x = currentX;
    this.y = currentY;
  }

  collect(targetX: number, targetY: number): void {
    if (this.isCollected) {
      return;
    }

    this.isCollected = true;
    this.collectionTimer = 0;
    this.targetX = targetX;
    this.targetY = targetY;
  }

  getIsCollected(): boolean {
    return this.isCollected;
  }

  isAnimationComplete(): boolean {
    return this.isCollected && this.collectionTimer >= this.collectionDuration;
  }

  getHitbox(): { x: number; y: number; width: number; height: number } {
    const hitboxWidth = this.sprite.width * 0.7;
    const hitboxHeight = this.sprite.height * 0.7;

    return {
      x: this.x - hitboxWidth / 2,
      y: this.y - hitboxHeight / 2,
      width: hitboxWidth,
      height: hitboxHeight,
    };
  }
}
